import { atom } from "jotai";

export const nodeIdToFocusAppSearch = atom<string | null>(null);

nodeIdToFocusAppSearch.debugLabel = "nodeIdToFocusAppSearch";
